import { createFileRoute, redirect } from "@tanstack/react-router";
import { queries } from "@/lib/queries";

/** Entrada do app: manda para o primeiro workspace, ou para criar um. */
export const Route = createFileRoute("/app/")({
  beforeLoad: async ({ context }) => {
    const workspaces = await context.queryClient.query(queries.workspaces());
    const first = workspaces[0];
    if (!first) throw redirect({ to: "/app/novo-workspace" });
    let lastId: string | null = null;
    try {
      lastId = localStorage.getItem("iagenix-ads-workspace");
    } catch {
      /* sem localStorage */
    }
    const target = workspaces.find((w) => w.id === lastId) ?? first;
    throw redirect({ to: "/app/$workspaceId", params: { workspaceId: target.id } });
  },
});
